import React from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '@config/firebase';
import { logError, logInfo } from '@utils/logger';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active', color: 'bg-green-500/20 text-green-400' },
  { value: 'pending', label: 'Pending', color: 'bg-yellow-500/20 text-yellow-400' },
  { value: 'paused', label: 'Paused', color: 'bg-orange-500/20 text-orange-400' },
  { value: 'road_survey_done', label: 'Road Survey Done', color: 'bg-blue-500/20 text-blue-400' },
  { value: 'waiting_approval', label: 'Waiting Approval', color: 'bg-purple-500/20 text-purple-400' },
  { value: 'review_required', label: 'Review Required', color: 'bg-red-500/20 text-red-400' },
  { value: 'rejected', label: 'Rejected', color: 'bg-red-500/20 text-red-400' },
  { value: 'approved', label: 'Approved', color: 'bg-emerald-500/20 text-emerald-400' },
  { value: 'sent_to_customer', label: 'Sent to Customer', color: 'bg-indigo-500/20 text-indigo-400' },
  { value: 'archived', label: 'Archived', color: 'bg-gray-500/20 text-gray-400' }
];

export const StatusSelector = ({ survey }) => {
  const handleStatusChange = async (newStatus) => {
    try {
      const surveyRef = doc(db, 'surveys', survey.id);
      await updateDoc(surveyRef, {
        status: newStatus,
        updatedAt: new Date().toISOString()
      });

      // Dispatch event for status change
      window.dispatchEvent(new CustomEvent('surveyStatusChanged', {
        detail: { surveyId: survey.id, status: newStatus }
      }));

      logInfo(`Survey status updated to ${newStatus}`);
    } catch (error) {
      logError('Failed to update survey status:', error);
    }
  };

  const currentStatus = STATUS_OPTIONS.find(option => option.value === survey.status) || STATUS_OPTIONS[0];

  return (
    <div className="relative">
      <select
        value={survey.status}
        onChange={(e) => handleStatusChange(e.target.value)}
        className={`appearance-none ${currentStatus.color} px-4 py-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#2A2B2E] focus:ring-current`}
      >
        {STATUS_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};